<script>
  import MeteorList from "@/components/MeteorList.svelte";
  import dayjs from "dayjs";
  import "dayjs/locale/da";
  import { formatNumber } from "@/utils";
  export let route, send, receive, url, statusOptions;


</script>

<MeteorList
  collectionName="orders"
  unitName="ordre"
  unitNamePlural="ordrer"
  {...$$props}
  let:collection>
  <ul class="rows">
    <li class="hidden sm:flex font-bold py-1 px-2">
      <div class="w-2/12">ID</div>
      <div class="w-3/12">Kunde</div>
      <div class="w-2/12">Pris</div>
      <div class="w-2/12">Status</div>
      <div class="w-3/12">Dato</div>
    </li>
    {#each Object.entries(collection) as [key, item]}
      <li class="hover:bg-gray-100">
        <a
          href={url('./:id', { id: item._id })}
          class="flex flex-wrap py-1 px-2 hover:bg-gray-200">
          <div class="sm:w-2/12 w-full">{item._id}</div>
          <div class="sm:w-3/12 w-full">
            {item.customerName || '[ingen kunde]'}
          </div>
          <div class="sm:w-2/12 w-full">
            {formatNumber(item.totalPrice || 0, 2)}
          </div>
          <div class="sm:w-2/12 w-full">
            <span
              class={'btn solid sm ' + (item.status === 'finished' ? 'green' : 'orange')}>
              {item.status && statusOptions.filter(so => so.value === item.status)[0].name}
            </span>
          </div>
          <div>{dayjs(item.updatedAt.$date).format('DD. MM. YYYY - HH:mm')}</div>
        </a>
      </li>
    {/each}
  </ul>
  <div slot="slot">
    <slot scoped={{ statusOptions }}>
      <!-- optional fallback -->
    </slot>
  </div>
</MeteorList>
